// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3IIzN","content":"GlobalSearch_content__1Q3E7"};